import { Components, Theme } from '@mui/material';

export const MuiRadio: Components<Theme>['MuiRadio'] = {
  styleOverrides: {
    root: ({ theme: { palette, spacing } }) => ({
      color: palette.grey[500],
      padding: spacing(1),

      '&&.Mui-disabled': {
        color: palette.text.disabled,
      },
    }),
  },
};
